import React from 'react';

// helpers
import {useTranslation} from 'react-i18next';

// components
import {CardLoanRequest} from './components';

// styles
import {
  LoanRequestsWrapper,
  SectionLoanRequestsWrapper,
} from './SectionLoanRequests-styles';
import {Subtitle, TextColors} from '../../../../shared/styles';

// types
import {GetLoanRequest} from '../../../../shared/services/ApiService/types';

type Props = {
  loanRequests: GetLoanRequest[];
};

const SectionLoanRequests = ({loanRequests}: Props) => {
  const {t} = useTranslation();

  // When API is ready for new loan requests, remove this condition
  if (loanRequests.length === 0) {
    return null;
  }

  return (
    <SectionLoanRequestsWrapper>
      <Subtitle color={TextColors.secondary} bold="bold">
        {t('loan_loanRequests')}
      </Subtitle>
      <LoanRequestsWrapper>
        {loanRequests.map((loanRequest, index) => (
          <CardLoanRequest key={index} loanRequest={loanRequest} />
        ))}
        {/* When API is ready for new loan requests, show CardRequestNewLoan */}
        {/* <CardRequestNewLoan /> */}
      </LoanRequestsWrapper>
    </SectionLoanRequestsWrapper>
  );
};

export default SectionLoanRequests;
